import {
    Avatar,
    Box,
    Button,
    Checkbox,
    FormControl,
    MenuItem,
    Select,
    Stack,
    Tooltip,
    Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useDebounce from "../../../hooks/use.debounce";

import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import CommonModel from "../../../components/dialog/Common";
import { CustomSearchInput, FOLLOWERS_ARRAY, FORM_SELECTFIELD_STYLES, getFixedValue, SOCIAL_PLATFORM, START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT, TABLE_BODY_ROW_MUI_STYLES, TABLE_HEADER_ROW_MUI_STYLES } from "../../../utils/constant";
import { addGroupMember, deleteCreator, getAllCreator } from "../../users/action";
import { updateUser } from "../../users/userSlice";
import { getAllSelectedInfluencers } from "../action";
import SelecetedUsers from "./selectedUsers";
import CustomPagination from "../../../utils/CustomPagination";

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, listing, selectedRows } = props;
    const { allcheckbox
    } = useSelector((state) => state.userSlice);
    const dispatch = useDispatch();
    const createSortHandler =
        (property) => (event) => {
            if (property === "date") {
                onRequestSort(event, property);
            }
            return;
        };
    const headCells = [
        {
            id: "name",
            numeric: false,
            disablePadding: true,
            label: "Name",
            type: "",
        },
        {
            id: "username",
            numeric: false,
            disablePadding: true,
            label: "Username",
            type: "",
        },
        {
            id: "Platform",
            numeric: false,
            disablePadding: true,
            label: "Platform",
            type: "",
        },
        {
            id: "niches",
            numeric: false,
            disablePadding: true,
            label: "Niches",
            type: "",
        },
        {
            id: "location",
            numeric: false,
            disablePadding: true,
            label: "location",
            type: "",
        },
        {
            id: "type",
            numeric: false,
            disablePadding: true,
            label: "Type",
            type: "",
        },
        {
            id: "action",
            numeric: false,
            disablePadding: true,
            label: "Action",
            type: "",
        },
    ];
    return (
        <TableHead className="hideActionSort">
            <TableRow sx={TABLE_HEADER_ROW_MUI_STYLES}>
                <TableCell>
                    <Checkbox
                        checked={allcheckbox}
                        onChange={(e) => {
                            if (e.target.checked) {
                                dispatch(updateUser({ selectedAllUserCheckbox: listing.filter((v) => !selectedRows.includes(v.id)).map((v) => v.id), allcheckbox: true }))
                            } else {
                                dispatch(updateUser({ selectedAllUserCheckbox: [], allcheckbox: false }))
                            }

                        }}
                        dis
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                </TableCell>
                {headCells.map((headCell) => {
                    return (
                        <TableCell
                            key={headCell?.id}
                            align={"left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sortDirection={orderBy == headCell.id ? order : false}
                            onClick={createSortHandler(headCell.id)}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}>
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
}


export default function InfluencersList({ details }) {
    const [order, setOrder] = useState("asc");

    const [listType, setListType] = useState(1);
    const { id } = useParams();

    const [orderBy, setOrderBy] = useState("date");
    const [deleteOpen, setDeleteOpen] = useState(0);
    const {
        niches,
    } = useSelector((state) => state.commonSlice);
    const [openTooltipIndexes, setOpenTooltipIndexes] = useState([]);
    const tooltipRefs = useRef([]);
    const handleTooltipToggle = (cellIndex) => {
        setOpenTooltipIndexes(openTooltipIndexes.includes(cellIndex) ? [] : [cellIndex]);
    };
    const handleDocumentClick = (event) => {
        const clickedOutsideAllTooltips = tooltipRefs.current.every(ref => ref && !ref.contains(event.target));
        if (clickedOutsideAllTooltips) {
            setOpenTooltipIndexes([]);
        }
    };
    useEffect(() => {
        document.addEventListener('click', handleDocumentClick);

        return () => {
            document.removeEventListener('click', handleDocumentClick);
        };
    }, []);
    const dispatch = useDispatch();
    const {
        limit,
        page,
        sort_key,
        totalPages,
        listing,
        filters,
        totalCount,
        selectedAllUserCheckbox, selectedRows
    } = useSelector((state) => state.userSlice);

    const debouncedSearch = useDebounce(filters.search, 500);


    const handleChange = (value) => {
        dispatch(updateUser({ page: value - 1 }));
        dispatch(getAllCreator());
    };

    const handleRequestSort = (
        event,
        property
    ) => {
        const isAsc = orderBy === property && order === "asc";

        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
        dispatch(
            updateUser({
                sort_type: isAsc ? "asc" : "desc",
                sort_key: property,
            }),
        );
        dispatch(getAllCreator());
    };

    useEffect(() => {
        if (debouncedSearch || filters.search == "")
            dispatch(getAllCreator());

    }, [debouncedSearch]);

    useEffect(() => {
        dispatch(getAllCreator());
        return () => dispatch(updateUser({ filters: {} }))
    }, []);

    const handleSearch = (event) => {
        dispatch(updateUser({ page: 0, filters: { ...filters, search: event.target.value } }));
    };
    const handleSearchClear = () => {
        dispatch(updateUser({ filters: { ...filters, search: "" } }));
        dispatch(getAllCreator());
    };

    useEffect(() => {
        dispatch(getAllSelectedInfluencers(id));
    }, [listing, dispatch, details]);


    const handleChangePerPage = (event, value) => {
        dispatch(updateUser({ limit: event.target.value, page: 0 }));
        dispatch(getAllCreator());
    };

    return (
        <>
            <Stack direction={"column"} gap={2}>
                <Stack
                    className="mainTitle  flex-wrap"
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    sx={{
                        minHeight: '42px',paddingX:'16px'
                    }}
                >
                    <Typography className="page-title" variant="h1">
                        Creator Listing
                    </Typography>
                    <Stack direction="row" gap={2} className="viewDetTabs mt-0 campaignDetails" bgcolor={"#F7F7F7"}>
                        <button className={listType == 1 ? "active" : ""} onClick={() => setListType(1)}>
                            All Users
                        </button>
                        <button className={(listType == 2 ? "active" : "") + " d-flex align-items-center"} onClick={() => setListType(2)}>
                            Selected Users {selectedRows.length > 0 && (listType === 1 ? <span>({selectedRows.length})</span> : <span>{selectedRows.length}</span>)}
                        </button>
                    </Stack>
                </Stack>
                <Box
                    sx={{
                        backgroundColor: '#fff',
                        transition: 'all .5s ease-in-out',
                        position: 'relative',
                        overflow: 'none',
                    }}>

                    {listType === 1 && <div className="myCmpny d-flex flex-wrap align-items-center justify-content-between searcFilter p-3">
                        <div className='allFilter campMgmt'>
                            <FormControl className="sContrl" variant="outlined" sx={{ marginRight: 'auto' }}>
                                <CustomSearchInput
                                    className="inputSearch p-0"
                                    value={filters.search}
                                    placeholder={"Search here..."}
                                    handleSearch={handleSearch}
                                    clearSearch={handleSearchClear}
                                    startAdornment={START_ADORNMENT_FOR_CUSTOM_SEARCH_INPUT}
                                />
                            </FormControl>

                        </div>
                        <div className='allFilter campMgmt'>
                            {selectedAllUserCheckbox.length > 1 &&
                                <Button variant="contained" onClick={() => {

                                    dispatch(updateUser({ allcheckbox: false, selectedRows: [...(selectedRows || []), ...listing.filter((v) => selectedAllUserCheckbox.includes(v.id))] }))
                                    dispatch(addGroupMember(id));
                                }}>Add Users</Button>}
                            <Select
                            sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '300px', width: '300px' }}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            borderRadius: "8px",
                                            mt: 1,
                                            maxHeight: 300,
                                            overflowY: 'auto',
                                        },
                                    },
                                }}
                                value={filters.search || ''}
                                name="search"
                                onChange={(e) => {
                                    dispatch(updateUser({ filters: { ...filters, search: e.target.value }, page: 0 }));
                                    dispatch(getAllCreator());
                                }}
                                displayEmpty
                                defaultValue={""}
                            >
                                <MenuItem value="" disabled hidden>
                                    Niche
                                </MenuItem>

                                {niches?.map((row) => (
                                    <MenuItem key={row} value={row}>
                                        {row}
                                    </MenuItem>
                                ))}
                            </Select>
                            <Select
                            sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '300px', width: '300px' }}
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            borderRadius: "8px",
                                                            mt: 1,
                                                        },
                                                    },
                                                }}
                                value={filters.platform || ""}
                                name="platform"
                                onChange={(e) => {
                                    dispatch(updateUser({ filters: { ...filters, platform: e.target.value }, page: 0 }));
                                    dispatch(getAllCreator());
                                }}
                                displayEmpty>
                                <MenuItem value="" disabled hidden>
                                    Platform
                                </MenuItem>
                                {SOCIAL_PLATFORM.map((item) => (
                                    <MenuItem key={item} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                            <Select
                            sx={{ ...FORM_SELECTFIELD_STYLES, maxHeight: '48px', maxWidth: '300px', width: '300px' }}
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            borderRadius: "8px",
                                                            mt: 1,
                                                        },
                                                    },
                                                }}
                                value={filters.followers || ''}
                                name="followers"
                                onChange={(e) => {
                                    dispatch(updateUser({ filters: { ...filters, followers: e.target.value }, page: 0 }));
                                    dispatch(getAllCreator());
                                }}
                                displayEmpty
                                defaultValue={""}
                            >
                                <MenuItem value="" disabled hidden>
                                    Followers
                                </MenuItem>

                                {FOLLOWERS_ARRAY.map((row) => (
                                    <MenuItem key={row.value} value={row.value}>
                                        {row.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>

                    </div>}


                    {listType === 1 ? <TableContainer >
                        <Table
                             aria-label="sticky table"
                        >
                            <EnhancedTableHead
                                listing={listing}
                                order={order}
                                orderBy={sort_key}
                                onRequestSort={handleRequestSort}
                                selectedRows={selectedRows?.map((v) => v.id)}
                                numSelected={0}
                                onSelectAllClick={function (

                                ) {
                                    throw new Error("Function not implemented.");
                                }}
                            />

                            <TableBody>
                                {listing && listing?.length ? (
                                    listing?.map((row, index) => {
                                        let username = row?.platforms?.map((v) => v?.username)?.filter((v) => v);
                                        let niches = row?.profileNiche ? JSON?.parse(row?.profileNiche)?.map((v) => v.option)?.toString() || "N/A" : "N/A";
                                        const cellTooltipIndex = index;
                                        const isOpen = openTooltipIndexes.includes(cellTooltipIndex);
                                        const rowsSelected = selectedRows.map((v) => v.id);
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={selectedAllUserCheckbox?.includes(row.id)}
                                                tabIndex={-1}
                                                key={row.id}
                                                selected={selectedAllUserCheckbox?.includes(row.id)}
                                                sx={TABLE_BODY_ROW_MUI_STYLES}
                                            >
                                                <TableCell>
                                                    <Checkbox
                                                        disabled={rowsSelected.includes(row.id)}
                                                        checked={selectedAllUserCheckbox?.includes(row.id)}
                                                        onChange={(e) => {
                                                            if (rowsSelected.includes(row.id)) return;
                                                            if (e.target.checked) {
                                                                dispatch(updateUser({ selectedAllUserCheckbox: [...selectedAllUserCheckbox, row.id] }))
                                                            } else {
                                                                dispatch(updateUser({ selectedAllUserCheckbox: selectedAllUserCheckbox.filter((v) => v !== row.id) }))
                                                            }

                                                        }}
                                                        sx={{ cursor: rowsSelected.includes(row.id) ? 'not-allowed' : "" }}
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                    />

                                                </TableCell>

                                                <TableCell component="td" scope="row" padding="none">
                                                    <Stack direction={"row"} >
                                                        <Avatar
                                                            alt="Remy Sharp"
                                                            src={row.picture}
                                                            sx={{ height: '35px', width: '35px', borderRadius: "50%" }}
                                                        />
                                                        <Link

                                                            className="text-decoration-none text-capitalize"
                                                            style={{ fontSize: '13px', fontWeight: '500', letterSpacing: '0px', marginLeft: '8px', position: "relative", top: 5 }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                window.open(`/userManagement/details/${row.id}`)
                                                            }}
                                                        >
                                                            {row?.name || "N/A"}
                                                        </Link>
                                                    </Stack>
                                                </TableCell>

                                                <TableCell component="td" scope="row" padding="none">

                                                    {username?.length > 0 ? username?.toString() : "N/A"}
                                                </TableCell>
                                                <TableCell component="td" scope="row" padding="none">
                                                    {row?.platforms?.map((v) => parseInt(v?.followers))?.filter((v) => v)?.length > 0 ? getFixedValue(row?.platforms?.map((v) => parseInt(v?.followers))?.filter((v) => v)?.reduce((a, b) => Math?.max(a, b))) : "N/A"}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {niches != null && niches.length > 20 ? (
                                                        <div >
                                                            <Tooltip
                                                                ref={ref => tooltipRefs.current[cellTooltipIndex] = ref}
                                                                title={niches}
                                                                PopperProps={{
                                                                    disablePortal: true,
                                                                }}
                                                                arrow={true}
                                                                open={isOpen}
                                                                disableFocusListener
                                                                disableTouchListener
                                                                disableInteractive
                                                            >
                                                                <span
                                                                    className="showhandCursor"
                                                                    onClick={() => handleTooltipToggle(cellTooltipIndex)}
                                                                >
                                                                    {niches.slice(0, 20)}
                                                                </span>
                                                            </Tooltip>
                                                            {!isOpen && <Tooltip title={niches} arrow={true}>
                                                                <span className="showhandCursor">...</span>
                                                            </Tooltip>}
                                                        </div>
                                                    ) : (
                                                        <span>{niches}</span>
                                                    )}

                                                </TableCell >

                                                <TableCell component="td" scope="row" padding="none">
                                                    {(row?.state ? row?.state : "N/A")}
                                                </TableCell>
                                                <TableCell component="td" scope="row" padding="none">
                                                    {row?.platforms?.map((v) => parseInt(v?.followers))?.filter((v) => v)?.length > 0 ? getFixedValue(row?.platforms?.map((v) => parseInt(v?.followers))?.filter((v) => v)?.reduce((a, b) => Math?.max(a, b))) : "N/A"}

                                                </TableCell>
                                                <TableCell component="td" scope="row" padding="none">
                                                    <Button onClick={() => {
                                                        dispatch(updateUser({ selectedRows: [...(selectedRows || []), row], selectedAllUserCheckbox: selectedAllUserCheckbox.filter((v) => v !== row.id) }))
                                                        dispatch(addGroupMember(id));
                                                    }} variant="contained" disabled={rowsSelected.includes(row.id)} size="small"> Add</Button>
                                                </TableCell>

                                            </TableRow >
                                        );
                                    })
                                ) : (
                                    <TableRow colSpan={11}>
                                        <TableCell colSpan={11} style={{ textAlign: 'center', height: "250px" }}>

                                            <Typography
                                                color="inherit"
                                                variant="subtitle1"
                                                alignItems={"center"}
                                                component="h3"
                                            >
                                                No Data found!
                                            </Typography>

                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody >
                        </Table >
                    </TableContainer > : <SelecetedUsers />}
                    {listType === 1 &&
                    <Stack
                                    sx={{
                                        background: 'transparent',
                                        height: '60px',
                                        border: '1px solid #E9EAEB'
                                    }}
                                    direction="row"
                                    alignItems={"center"}
                                    justifyContent={"flex-end"}>
                                    <CustomPagination
                                        count={Math.ceil(totalPages / limit) || 0}
                                        onChange={handleChange}
                                        currentPage={page}
                                        listingCount={listing?.length}
                                        totalCount={totalCount}
                                        limit={limit}
                                        handleChangePerPage={handleChangePerPage}
                                        defaultPage={1} siblingCount={1} boundaryCount={1} />
                                </Stack>}
                </Box >
            </Stack >
            <CommonModel
                open={deleteOpen}
                handleDialogClose={() => setDeleteOpen(false)}
                dialogTitle={"Delete Creator"}
                className={"btnDanger"}
                dialogPara={`Are you sure you want to delete this creator? `}
                nvYes={"Delete"}
                nvCancel={"Cancel"}
                yesHandle={() => {
                    dispatch(deleteCreator(deleteOpen));
                    setDeleteOpen(false);
                }}
            />
        </>
    );
}
